import { FormEvent } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { SetState } from "zustand";
import { ICivilCPFNominalStore } from "..";
import { IConsultaCivil } from "../../../interface/civil";

export interface ICivilCPFModuleStore {
  resultadoCivilCPF: IConsultaCivil[] | null;
  mensagemCivil?: string;
  consultaCivilCPF(url: string, cpf: string, e?: FormEvent): Promise<void>;
  limparConsultaCivilCPF(): void;
}

export default (set: SetState<ICivilCPFNominalStore>) =>
  ({
    resultadoCivilCPF: null,
    async consultaCivilCPF(url, cpf, e) {
      e?.preventDefault();
      try {
        const storedToken = sessionStorage.getItem("@webSDS:token");

        set((state) => ({
          ...state,
          global: {
            ...state.global,
            loading: true,
          },
        }));

        if (cpf === "") {
          toast.error("Preencha o campo!", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
          });
        } else {
          const response = await axios.get(
            `${url}/wsCivil/BuscarCidadaoPorCPF/${cpf}`,
            {
              headers: {
                Authorization: `Bearer ${storedToken}`,
              },
            }
          );

          if (response.status === 200) {
            set((state) => ({
              ...state,
              global: {
                ...state.global,
                loading: false,
              },
              civil: {
                ...state.civil,
                resultadoCivilCPF: response.data,
              },
            }));
          }
          if (response.status === 400) {
            toast.error(`${response.data}`, {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 4000,
            });
          }
          if (response.status === 401) {
            toast.error(
              "A SUA SESSÃO EXPIROU, EFETUE LOGIN NOVAMENTE PARA CONTINUAR USANDO O POLÍCIA ÁGIL.",
              {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 4000,
              }
            );
            // logout()
          }
          if (response.status === 404) {
            // toast.error(`${response.data}`, {
            //   position: toast.POSITION.TOP_CENTER,
            //   autoClose: 4000,
            // })
            set((state) => ({
              civil: {
                ...state.civil,
                resultadoCivilCPF: null,
                mensagemCivil: response.data,
              },
            }));
          }
          if (response.status === 500 || response.status === 503) {
            toast.error("ERRO NO SERVIDOR, TENTE MAIS TARDE!", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 4000,
            });
            return;
          }
          if (response.status === 504 || response.data === 504) {
            toast.error(
              "O SERVIDOR DEMOROU MUITO PARA RESPONDER, TENTE NOVAMENTE EM INSTANTES.",
              {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 4000,
              }
            );
            return;
          }
        }
      } catch (error) {
        toast.error("ERRO DE CONEXÃO! VERIFIQUE SUA INTERNET! ", {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 4000,
        });
      } finally {
        set((state) => ({
          ...state,
          global: {
            ...state.global,
            loading: false,
          },
        }));
      }
    },
    limparConsultaCivilCPF() {
      set((state) => ({
        ...state,
        civil: {
          ...state.civil,
          resultadoCivilCPF: null,
          mensagemCivil: undefined,
        },
      }));
    },
  } as ICivilCPFModuleStore);
